import { Button, Input, Modal } from "antd";
import { useEffect, useRef } from "react";

const TaansDetailsDialog = ({
  taansOpen,
  setTaansOpen,
  taansData,
  setTaansData,
  handleTaansBillSave,
}) => {
  const inputRef = useRef(null);
  const rateRef = useRef(null);
  const disPerRef = useRef(null);
  const disAmtRef = useRef(null);
  const saveRef = useRef(null);
  const handelCancel = () => {
    setTaansOpen(false);
    setTaansData([]);
  };
  useEffect(() => {
    if (taansOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [taansOpen]);

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      className="td-modal"
      title={<div className="td-title">Product Details</div>}
      open={taansOpen}
      closable={false}
      footer={null}
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      afterOpenChange={(open) => {
        if (open && inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .td-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .td-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .td-modal .ant-modal-body{padding:14px;background:#eef1f8}

        .td-title{background:linear-gradient(135deg,#114a3d,#1f8f6a);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:.4px}

        .td-head{background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 4px 12px rgba(22,37,102,.3)}
        .td-head-top{display:flex;align-items:center;justify-content:space-between;gap:10px}
        .td-head-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.85}
        .td-chip{background:linear-gradient(180deg,#ffd666,#f2b01e);color:#3b2a00;font-weight:800;font-size:17px;padding:4px 14px;border-radius:10px}
        .td-pname{margin-top:8px;font-size:13px;font-weight:700;color:#e6ebff;word-break:break-word}

        .td-grid{margin-top:10px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .td-card{background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 12px 10px;box-shadow:0 1px 4px rgba(0,0,0,.05)}
        .td-label{font-size:11px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px}
        .td-input{height:40px;border-radius:10px!important;font-size:16px;font-weight:700;color:#162566;width:100%}

        .td-result{margin-top:10px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .td-tile{border-radius:14px;padding:10px 12px;color:#fff}
        .td-tile.act{background:linear-gradient(135deg,#ffb020,#f08a00)}
        .td-tile.amt{background:linear-gradient(135deg,#1f8f6a,#52bd91)}
        .td-tile-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.9}
        .td-tile-v{font-size:20px;font-weight:800;margin-top:2px}

        .td-actions{margin-top:12px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .td-btn{height:44px!important;border-radius:12px!important;font-weight:800!important;font-size:14px!important}
        .td-cancel{background:#fff!important;border:1.5px solid #BF092F!important;color:#BF092F!important}
        .td-save{background:linear-gradient(135deg,#1f8f6a,#52bd91)!important;border:0!important;color:#fff!important}
      `}</style>

      {/* Design code + product name (read-only) */}
      <div className="td-head">
        <div className="td-head-top">
          <span className="td-head-l">Design Code</span>
          <span className="td-chip">{taansData[0]?.DesignCode || "-"}</span>
        </div>
        <div className="td-pname">{taansData[0]?.ProdName}</div>
      </div>

      <div className="td-grid">
        {/* Qty */}
        <div className="td-card">
          <div className="td-label">Qty</div>
          <Input
            placeholder="Enter Qty"
            className="td-input"
            ref={inputRef}
            inputMode="decimal"
            value={taansData[0]?.stock ?? 0}
            onFocus={(e) => e.target.select()}
            onChange={(e) => {
              const val = e.target.value;

              if (/^\d*\.?\d{0,2}$/.test(val)) {
                const maxQty = taansData[0]?.Qty ?? 0;

                if (val > maxQty) return;

                setTaansData((prev) =>
                  prev.map((item) =>
                    item.DesignCode === taansData[0]?.DesignCode
                      ? { ...item, stock: val ?? 0 }
                      : item
                  )
                );
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, rateRef);
            }}
          />
        </div>

        {/* Rate */}
        <div className="td-card">
          <div className="td-label">Rate</div>
          <Input
            placeholder="Enter Rate"
            className="td-input"
            ref={rateRef}
            inputMode="decimal"
            value={taansData[0]?.CPrice ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                const disPer = taansData[0]?.Disper;
                const rateValue = val * Number(disPer);
                const disAmt = Number(rateValue) / 100;
                const ActRate = val - Number(disAmt);

                setTaansData((prev) =>
                  prev.map((item) =>
                    item.DesignCode === taansData[0]?.DesignCode
                      ? {
                        ...item,
                        CPrice: val,
                        Disamt: disAmt,
                        offer: ActRate,
                      }
                      : item
                  )
                );
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disPerRef);
            }}
          />
        </div>

        {/* Dis Per */}
        <div className="td-card">
          <div className="td-label">Dis Per (%)</div>
          <Input
            placeholder="Enter Dis Per"
            className="td-input"
            ref={disPerRef}
            inputMode="decimal"
            value={taansData[0]?.Disper ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (!/^\d*\.?\d*$/.test(val)) return;
              const rate = taansData[0]?.CPrice;
              const rateValue = rate * val;
              const disAmt = rateValue / 100;
              const ActRate = rate - disAmt;

              setTaansData((prev) =>
                prev.map((item) =>
                  item.DesignCode === taansData[0]?.DesignCode
                    ? {
                      ...item,
                      Disper: val,
                      Disamt: disAmt,
                      offer: ActRate,
                    }
                    : item
                )
              );
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disAmtRef);
            }}
          />
        </div>

        {/* Dis Amt */}
        <div className="td-card">
          <div className="td-label">Dis Amt</div>
          <Input
            placeholder="Enter Dis Amt"
            className="td-input"
            ref={disAmtRef}
            inputMode="decimal"
            value={taansData[0]?.Disamt ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                //   const updatedValue = val === 0 ? 0 : Number(val);
                const rate = taansData[0]?.CPrice;
                const ActRate = rate - val;

                setTaansData((prev) =>
                  prev.map((item) =>
                    item.DesignCode === taansData[0]?.DesignCode
                      ? { ...item, Disamt: val, offer: ActRate }
                      : item
                  )
                );
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, saveRef);
            }}
          />
        </div>
      </div>

      {/* Act Rate / Amount (read-only) */}
      <div className="td-result">
        <div className="td-tile act">
          <div className="td-tile-l">Act Rate</div>
          <div className="td-tile-v">
            {Number(taansData[0]?.offer)?.toFixed(2) || 0}
          </div>
        </div>
        <div className="td-tile amt">
          <div className="td-tile-l">Amount</div>
          <div className="td-tile-v">
            {Number(taansData[0]?.stock * taansData[0]?.offer)?.toFixed(2) || 0}
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="td-actions">
        <Button
          className="td-btn td-cancel"
          onClick={() => {
            handelCancel();
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="td-btn td-save"
          ref={saveRef}
          onClick={() => {
            handleTaansBillSave();
          }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
export default TaansDetailsDialog;